import { SHARED_REACT_QUERY_CONFIG } from '../../constants/reactQuery.constant';
import { policies } from '../../services/policy/policy.service';

export const POLICIES_QUERY = 'policies';
export const POLICIES_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const policiesQuery = async ({ queryKey, pageParam = 1 }: any) => {
  const params = queryKey[1];
  const request = await policies(params.value && [params], pageParam);
  return request.data;
};
